import { z } from 'zod/v3';
import { AlgorithmMappingMutationDtoSchema } from './AlgorithmMappingMutationDto';

export const AlgorithmMappingsMutationDtoSchema = z.object({
  mappings: AlgorithmMappingMutationDtoSchema.array(),
});
